export const TipoUtenteEnum = {
  Pf: 'PF',
  Pg: 'PG',
  Fid: 'Fid',
  Fdn: 'Fdn',
} as const;

export type TipoUtenteEnum =
  (typeof TipoUtenteEnum)[keyof typeof TipoUtenteEnum];
